<nav class="navbar navbar-expand-lg navbar-dark">
  <div class="container-fluid">
    <!-- Brand/Logo -->

    <!-- Mobile toggle button -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Navigation items -->
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto">
        <!-- Print Invoice -->
        <li class="nav-item">
          <a class="nav-link" routerLink="/reports/printCertificate" routerLinkActive="active">
            <i class="fa fa-print me-1"></i>
            Print Invoice
          </a>
        </li>
        
        <!-- Invoice Report -->
        <li class="nav-item">
          <a class="nav-link" routerLink="/reports/certificateReport" routerLinkActive="active">
            <i class="fa fa-file-text me-1"></i>
            Invoice Report
          </a>
        </li>
        
        <!-- Reconciliation Report -->
        <li class="nav-item">
          <a class="nav-link" routerLink="/reports/reconciliationReport" routerLinkActive="active">
            <i class="fa fa-check-circle me-1"></i>
            Reconciliation Report
          </a>
        </li>
      </ul>

     </div>
  </div>
</nav>
